import Component from '@bythepixel/component-loader';

const DEFAULTS = {};

export default class NavController extends Component {
  static selector = '[data-comp-nav-controller]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.panels = containerEl.querySelectorAll(options.panelSelector);
    this.headerEl = document.body.querySelector('.header');
    this.scrollingBlocked = false;
    this.mount();
  }

  #attachListeners() {
    window.addEventListener('scroll', () => {
      const { headerEl } = this;
      const { scrollY } = window;
      const headerBackgroundVisible = headerEl.classList.contains('fade-in');

      if (scrollY > 0 && !headerBackgroundVisible) {
        headerEl.classList.add('fade-in');
        return;
      }

      if (scrollY === 0 && headerBackgroundVisible) {
        headerEl.classList.remove('fade-in');
      }
    });
  }

  mount() {
    this.#attachListeners();

    const { scrollY } = window;

    if (scrollY > 0 && !this.headerEl.classList.contains('fade-in')) {
      this.headerEl.classList.add('fade-in');
    }
  }
}
